import { FC, useEffect, useState } from 'react';
import ForgetPassword from './components/ForgetPassword';
import ResetPassword from './components/ResetPassword';
import logoIcon from '@/images/logo-bule.svg';
import rightIcon from '@/images/common/dir/hollow-right.svg';
import { HeaderCSS, SystemWrap } from './style';
import Login, { IShowType } from './components/Login';
import { useTranslation } from 'react-i18next';
import { AreaEnum } from '@hylaa-npm/ipod';
import { getStorage } from '@/utils/storage';
import { getLocalLangs } from '@/utils/lang';
import { Tooltip } from 'antd';

const System: FC<{}> = () => {
	const { t } = useTranslation();
	const [isMember, setIsMember] = useState(true);
	const [showType, setShowType] = useState<IShowType>(IShowType.LOGIN);
	const [flagNum, setflagNum] = useState(0);
	const [passwordCode, setPasswordCode] = useState<IRestPasswordParams>();
	const [account, setAccount] = useState<{ areaCode: AreaEnum; mobile: string }>({
		areaCode: AreaEnum.HK,
		mobile: '',
	});
	useEffect(() => {
		if (isMember) {
			if (getStorage('memberAccount')) {
				let memberAccount = getStorage('memberAccount');
				setAccount(memberAccount);
				let account = memberAccount.areaCode + memberAccount.mobile;
				getLocalLangs(account);
			} else {
				setAccount(() => {
					return {
						areaCode: AreaEnum.HK,
						mobile: '',
					};
				});
			}
		} else {
			if (getStorage('adminAccount')) {
				let adminAccount = getStorage('adminAccount');
				setAccount(adminAccount);
				let account = adminAccount.areaCode + adminAccount.mobile;
				getLocalLangs(account);
			} else {
				setAccount(() => {
					return {
						areaCode: AreaEnum.HK,
						mobile: '',
					};
				});
			}
		}
	}, [isMember, flagNum]);

	const handlePageChange = (page: IShowType, body?: IRestPasswordParams) => {
		if (body) {
			setPasswordCode(body);
		}
		setShowType(page);
	};

	const handleSwitech = () => {
		if (showType === IShowType.LOGIN) {
			setIsMember(!isMember);
		} else {
			setShowType(IShowType.LOGIN);
		}
		setflagNum(flagNum + 1);
	};
	const goToForget = () => {
		setShowType(IShowType.FORGET);
	};
	return (
		<SystemWrap>
			<Tooltip
				title={isMember ? '可切换登陆后台管理' : '可切换登陆用户端'}
				mouseEnterDelay={3}
				mouseLeaveDelay={0.5}>
				<div className="switch-button" onClick={handleSwitech}>
					{isMember ? t('common.adminLogin') : t('common.back')}
					<img src={rightIcon} alt="" />
				</div>
			</Tooltip>
			<HeaderCSS>
				<img src={logoIcon} alt="logo" />
				<div className="title">{t('common.centerSer')}</div>
			</HeaderCSS>
			{showType === IShowType.FORGET && <ForgetPassword pageChange={handlePageChange} />}
			{showType === IShowType.RESET && (
				<ResetPassword pageChange={handlePageChange} body={passwordCode} handleBack={goToForget} />
			)}
			{showType === IShowType.LOGIN && (
				<Login
					showMember={isMember}
					pageChange={handlePageChange}
					key={flagNum + JSON.stringify(account)}
					account={account}
				/>
			)}
		</SystemWrap>
	);
};

export default System;
